<div class="search-results-item d-flex align-items-center">
  <div class="d-flex align-items-center">
    <div class="avatar">
      <a [profile]="organization">
        <img [src]="organization.icon | baseUrl" class="img-fluid" />
      </a>
    </div>
    <div>
      <div class="name">
        <a [profile]="organization"> {{ organization.name | textTruncate: 50 }} </a>
        <svg viewBox="0 0 20 20" *ngIf="organization?.is_creditable" class="verify-icon">
          <use href="#verified" />
        </svg>
      </div>
      <div class="desc">{{ organization.type_name }}</div>
    </div>
  </div>
  <a href="" class="link ml-auto" *ngIf="!organization.is_friend" (click)="onSubscribe(organization.id); false"
    >Follow</a
  >

  <a href="" class="link ml-auto" *ngIf="organization.is_friend" (click)="onUnSubscribe(organization.id); false"
    >Un-Follow</a
  >
</div>
